export default "__VITE_ASSET__DWv1WdHc__"